import BetaAlert from "components/Beta/BetaAlert";
import type { GetDataWrapperResult } from "components/MutateWrapper.tsx";
import BlockSpinner from "components/Spinners/BlockSpinner";
import AggregatedTimeSeriesQueryForm, {
  type AggregatedTimeSeriesQueryFormValues,
  mapTimeSeriesRequestParamsToFormValues,
} from "components/TimeSeries/AggregatedTimeSeriesQueryForm/AggregatedTimeSeriesQueryForm";
import {
  type NewTimeSeriesRequestParams,
  getUnitsForParameter,
} from "components/TimeSeries/model";
import AggregatedStatsChart from "components/charts/AggregatedStatsChart";
import AggregationDistributionChart from "components/charts/AggregationDistributionChart";
import type {
  AssetRegisterAggregatedTimeSeriesResponse,
  GetTimeSeriesReportStatsReportTimeSeriesStatsPostMutationResponse,
} from "kubb";
import { startCase } from "lodash-es";

interface AggregatedTimeSeriesStatsReportViewProps {
  onSubmit: (v: AggregatedTimeSeriesQueryFormValues) => Promise<any>;
  request: NewTimeSeriesRequestParams;
  data: GetDataWrapperResult<GetTimeSeriesReportStatsReportTimeSeriesStatsPostMutationResponse>;
  aggregatedData?: GetDataWrapperResult<AssetRegisterAggregatedTimeSeriesResponse>;
  company_id: string;
  scheme_id?: string;
  showForm?: boolean;
}

function AggregatedTimeSeriesStatsReportView(
  props: AggregatedTimeSeriesStatsReportViewProps,
) {
  const { data, error, loading, refresh } = props.data;
  const haveScheme = props.scheme_id !== undefined;
  const { request, showForm = true } = props;
  return (
    <>
      {showForm && (
        <>
          <AggregatedTimeSeriesQueryForm
            onSubmit={props.onSubmit}
            initialValues={mapTimeSeriesRequestParamsToFormValues(request)}
            wide={true}
            showErrors={false}
            showGroup={true}
            showGroupByScheme={!haveScheme}
            showGroupByGroup={haveScheme}
            showassetUseCaseEnum={true}
          />
          <BetaAlert />
        </>
      )}
      <AggregatedStatsChart
        error={error || undefined}
        data={data}
        loading={loading}
        refresh={refresh}
        seriesName={`Mean of ${startCase(request.aggregation)} of ${request.parameter}`}
        units={request.units ?? getUnitsForParameter(request.parameter)}
        groupBy={request.group_by}
        groupFilter={request.group}
      />
      {props.scheme_id && props.aggregatedData && (
        <BlockSpinner loading={props.aggregatedData.loading}>
          <AggregationDistributionChart
            data={props.aggregatedData.data}
            loading={props.aggregatedData.loading}
            error={props.aggregatedData.error}
            parameter={request.parameter}
            aggregation={request.aggregation}
            unit={request.units ?? getUnitsForParameter(request.parameter)}
            company_id={props.company_id}
            scheme_id={props.scheme_id as string}
            start_time={request.start_date}
            end_time={request.end_date}
          />
        </BlockSpinner>
      )}
    </>
  );
}

export default AggregatedTimeSeriesStatsReportView;
